/**
 * @components register
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import { Input, Select } from 'antd'
import './index.scss'
import { postRegister } from 'src/apis/user'
import { changePopup } from 'src/redux/basicInfo'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

const { Option } = Select

@withTranslation()
@connect((state) => state, { changePopup })
class Register extends Component {
  constructor(props) {
    super(props)
    this.state = {
      time: 0,
      phone: '',
      pwd: '',
      vertical: '',
    }
  }

  componentDidMount() { }

  handleClickRetrieve = () => {
    this.props.changePopup({ type: 'retrieve', status: true })
  }

  countDown = () => {
    let time = 60
    let timer = setInterval(() => {
      if (time > 0) {
        time -= 1
        this.setState({ time })
      } else {
        clearInterval(timer)
      }
    }, 1000)
  }

  handleClickVertical = () => {
    let { time } = this.state
    if (time === 0) {
      this.countDown()
    } else {
      return
    }
  }

  handleRegister = () => {
    let { phone, pwd, vertical } = this.state
    if (phone && pwd && vertical) {
      postRegister({ phone, pwd, vertical }).then((res) => {
        console.log(res)
      })
    }
  }

  handlePhone = (e) => {
    // console.log(e.target.value)
    let phone = e.target.value
    this.setState({ phone })
  }

  handleVertical = (e) => {
    // console.log(e.target.value)
    let vertical = e.target.value
    this.setState({ vertical })
  }

  handlePassword = (e) => {
    // console.log(e.target.value)
    let pwd = e.target.value
    this.setState({ pwd })
  }

  onFinish = (values) => {
    console.log('Received values of form: ', values)
  }

  render() {
    let { t } = this.props;
    const options = [
      {
        value: 'US+1',
        label: 'US+1',
      },
      {
        value: 'US+21',
        label: 'US+21',
      },
    ]
    let { time } = this.state
    return (
      <div className="login">
        <div className="login-layout">
          <div className="text">手机号/Phone</div>
          <Select defaultValue="CN+86">
            {options.map((item, index) => (
              <Option key={'select-' + index} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
          <Input maxLength="11" onChange={this.handlePhone}></Input>
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout">
          <div className="text">验证码/Code</div>
          <Input maxLength="6" onChange={this.handleVertical} />
          <div className="vertical" onClick={this.handleClickVertical}>
            {time === 0 ? t('popout:register_verify') : time + ' s'}
          </div>
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout">
          <div className="text">密码/Password</div>
          <Input.Password
            maxLength="32"
            onChange={this.handlePassword}
          ></Input.Password>
        </div>
        <div className="login-layout-extra">
          <div className="extra-left"></div>
          <div className="extra-right">
            <span
              className="extra-right__password"
              onClick={this.handleClickRetrieve}
            >
              {t('popout:register_forget')}
            </span>
          </div>
        </div>
        <div className="login-button" onClick={this.handleRegister}>
          {t('popout:register')}
        </div>
        <div className="login-layout-extra">
          <p>
            {t('popout:register_tip')}
            {/* 点击注册，则表示我已阅读并接受<a>哈兔用户条款</a>和<a>隐私政策</a> */}
          </p>
        </div>
      </div>
    )
  }
}

export default Register
